import { FC } from 'react';
import { Texts } from 'components/shared/Texts';
import { Button } from 'components/shared/Button';
import { useForm } from 'react-hook-form';
import { useAppDispatch, useAppSelector } from 'redux/store';
import { fetchAdminLogin } from 'redux/admin/thunks';
import { AdminLogin } from 'api/adminApi';
import { yupResolver } from '@hookform/resolvers/yup';
import { loginSchema } from './schema';
import {
  selectIsLoading,
  selectIsRejected,
  selectRejectedMessage,
} from 'redux/admin/selectors';
import { FormInputText } from 'components/shared/FormInputText';
import styles from '../AdminView.module.scss';
import { AdminPanel } from 'utils/strings';

const LoginView: FC = () => {
  const dispatch = useAppDispatch();
  const isLoading = useAppSelector(selectIsLoading);
  const isRejected = useAppSelector(selectIsRejected);
  const error = useAppSelector(selectRejectedMessage);
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<AdminLogin>({
    defaultValues: {
      username: '',
      password: '',
    },
    mode: 'all',
    resolver: yupResolver(loginSchema),
  });

  const onSubmit = (data: AdminLogin) => {
    const bodyFormData = new FormData();
    bodyFormData.append('username', data.username);
    bodyFormData.append('password', data.password);
    void dispatch(fetchAdminLogin(bodyFormData));
  };
  return (
    <form
      className={styles.login_view}
      onSubmit={(event) => void handleSubmit(onSubmit)(event)}
    >
      <Texts className={styles.text}> {AdminPanel.SigIn.h1} </Texts>
      <FormInputText
        name="username"
        placeholder={AdminPanel.SigIn.email}
        control={control}
        error={!!errors.username}
        type="text"
      />
      <FormInputText
        name="password"
        placeholder={AdminPanel.SigIn.password}
        error={!!errors.password}
        control={control}
        type="password"
      />

      {(isRejected || error === AdminPanel.Errors.Api.invalidCredentials) && (
        <div className={styles.login_error}>
          <Texts className={styles.error_text}>
            <span className={styles.text_icon}></span>
            {isRejected
              ? AdminPanel.Errors.incorrectEmailOrPassword
              : AdminPanel.Errors.invalidToken}
          </Texts>
        </div>
      )}
      <a className={styles.reset} href={'/admin/reset-password'}>
        {AdminPanel.SigIn.reset}
      </a>
      <Button
        className={styles.button_styles}
        buttonType="submit"
        disabled={isLoading || !!errors.password || !!errors.username}
      >
        {AdminPanel.SigIn.logIn}
      </Button>
    </form>
  );
};
export default LoginView;
